// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3QFD0","amount":"Amount_amount__1YoTW","tip":"Amount_tip__--but","tipHeader":"Amount_tipHeader__2DX9D","tipsWrap":"Amount_tipsWrap__3kJek"};